import React from "react";
import InfoSection from "@components/pages/info/info_section";
import BannedCross from "@components/icons/BannedIcon";
import { FlexContainer } from "@components/ui/flex_container";

function ServiceNumber() {
    return (
        <InfoSection title="Bannmerking">
            <FlexContainer justifyContent="between" alignItems="middle">
                <h4>Hvað þýðir bannmerking við símanúmer?</h4>
                <BannedCross height={30} width={30} />
            </FlexContainer>
            <p>
                Hægt er að óska eftir því að setja bannmerki, eins og það sem er á myndinni hér að
                neðan, við símanúmerið sitt á 1819.is.
            </p>
            <p>
                Sé slíkt bannmerki við símanúmer þýðir það að rétthafi númersins hefur óskað eftir
                að vera ekki ónáðaður af aðilum sem stunda beina markaðsetningu.
            </p>
            <p>
                Í 5. mgr. 46 gr. fjarskiptalaga segir: „Notendur sem nota almenna talsímaþjónustu
                sem lið í markaðssetningu skulu virða merkingar í símaskrá sem gefur til kynna að
                viðkomandi áskrifandi vilji ekki slíkar hringingar í símanúmerið sitt.“
            </p>
            <p>
                1819 ber ekki ábyrgð á því að notendur virði ekki bannmerki sem skráð eru á
                símanúmer á 1819.is
            </p>
            <p>Hægt er að skrá bannmerki við símanúmer í gegnum Mínar síður</p>
        </InfoSection>
    );
}
export default ServiceNumber;
